import styles from './YoutubeEmbed.module.scss';

interface YoutubeEmbedProps {
  embedId: string;
}

export default function YoutubeEmbed({ embedId }: YoutubeEmbedProps) {
  return (
    <div className={styles.webinarVideo}>
      <iframe
        title="youtube-iframe"
        width="640"
        height="360"
        src={`https://www.youtube.com/embed/${embedId}`}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
}
